export const comCopy = {
  com_layout_title: "How to set up TypeScript",
  com_layout_description:
    "Connect with other TypeScripters online and offline.",
  com_headline: "Connect with us",
  com_connect_online: "Online",
  com_connect_online_description:
    " Tell us what’s working well, what you want to see added or improved, and find out about new updates.",
  com_online_stack_overflow_desc:
    "Engage with your peers and ask questions about TypeScript using the tag 'typescript'",
  com_online_stack_overflow_tag: "",
  com_online_discord_header: "Chat",
  com_online_discord_desc:
    "Chat with other TypeScript users in the TypeScript Community Chat.",
  com_online_github_desc:
    "Found a bug, or want to give us constructive feedback?",
  com_online_github_href: "Tell us on GitHub",
  com_online_twitter_desc: "Stay up to date. Follow us on Twitter",
  com_online_blog_desc:
    "Learn about the latest TypeScript developments via our",
  com_online_typed_desc: "TypeScript definition files",
  com_online_typed_href: "Browse the thousands of",
  com_online_typed_available_for:
    "available for common libraries and frameworks.",
  com_person: "Connect in person",
  com_conferences: "Conferences",
  com_conferences_alt_img: "logo of ",
  nav_: {
    id: "foo",
    defaultMessage: "foo",
  },
}
